import environment from '~/platform/utilities/environment';

export const SUBMIT_URL = `${
  environment.API_URL
}/v0/education_benefits_claims/10275`;

export const TITLE =
  'Commit to the Principles of Excellence for educational institutions';
export const SUBTITLE =
  'Principles of Excellence for educational institutions (VA Form 22-10275)';
